import { render, staticRenderFns } from "./list copy.vue?vue&type=template&id=2db40b8d"
import script from "./list copy.vue?vue&type=script&lang=js"
export * from "./list copy.vue?vue&type=script&lang=js"
import style0 from "./list copy.vue?vue&type=style&index=0&id=2db40b8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports